import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './Columns.module.css';
import { classNames } from '../../utils';
const autoTemplateOfSize = (size) => {
    return new Array(size).fill('auto').join(' ');
};
const Columns = ({ template, children, gap = '0px' }) => {
    template = template || autoTemplateOfSize(React.Children.count(children));
    return (_jsx("div", Object.assign({ className: classNames(styles.root), style: {
            gridTemplateColumns: template || autoTemplateOfSize(React.Children.count(children)),
            gridColumnGap: gap,
        } }, { children: children }), void 0));
};
export default Columns;
